import { useAuthStore } from '@entities/auth/stores/useAuthStore';

/**
 * A skip and a recommendation each take one unit of the shared swipe limit:
 * their `remaining` is the swipe count, written where the dating deck reads
 * it.
 */
export const writeSwipeRemaining = (remaining: number | null) => {
  const { swipe_status: swipeStatus, setSwipeStatus } = useAuthStore.getState();

  setSwipeStatus({ ...swipeStatus, remaining });
};
